/**
 * @ngdoc object
 * @name components
 * @description
 *
 */
angular.module('festzelt-os.components.stats', [
    'festzelt-os.components'
]);

require('./components/billing/failed-payments/component');
require('./components/billing/latest-invoice-drafts/component');
require('./components/billing/invoices-paid-vs-open/component');

require('./components/guestlists/failed-messages/component');
require('./components/guestlists/rsvps-by-status/component');
require('./components/guestlists/latest-state-changes/component');
require('./components/guestlists/invited-vs-confirmed/component');
require('./components/guestlists/general/component');
require('./components/guestlists/bookable-objects/component');
require('./components/guestlists/seatplan-elements/component');
require('./components/guestlists/double-booked-seatplan-elements/component');
require('./components/guestlists/schuetzenfestzelt-quotas/component');



// WEBPACK FOOTER //
// ./src/app/components/stats/stats-module.js